import {BehaviorSubject, combineLatest, Subject} from 'rxjs';
import {map, skipUntil, switchMap, filter, startWith} from 'rxjs/operators';
import {marginTradeApi} from '@/api/margin-trade';
import {mc} from '@/core';
import {numUtil} from '@/helper/num';
import {timeUtil} from '@/helper/time';
import {browser$} from '@/streams/browser';
import {marginCurrencyMap$} from '@/streams/config/margin-trade';

export const BusinessMap = {
  0: 'ManualBorrow',
  2: 'MarginBorrow',
  3: 'UtaSpotBorrow',
  4: 'UtaMarginBorrow',
};

export const typeMap = {
  0: 'ManualBorrow',
  1: 'AutoBorrow',
};

export const loading$ = new Subject();
export const query$ = new Subject();

const borrows$ = new BehaviorSubject({total: 0, rows: []});
export const borrowList$ = combineLatest([borrows$, marginCurrencyMap$]).pipe(
  filter(([, marginCurrencyMap]) => Object.keys(marginCurrencyMap).length > 0),
  map(convertData),
  startWith({total: 0, rows: []})
);

const Limit = 10;

query$
  .pipe(
    skipUntil(browser$),
    switchMap((query) => loadBorrowList(query))
  )
  .subscribe((x) => borrows$.next(x));

async function loadBorrowList({current, currency, business}) {
  loading$.next(true);
  const query = {
    business,
    currency,
    pageNum: current,
    pageSize: Limit,
  };
  const {data, error} = await marginTradeApi.getBorrowHistory(query);
  loading$.next(false);
  if (data) {
    return data;
  }
  if (error) {
    mc.send('toast', 'error', error);
  }
  return {total: 0, rows: []};
}

function convertData([data, currencyMap]) {
  const {rows, total = 0} = data;
  const list = rows.map((o) => {
    const currency = currencyMap[o.currency];
    const {valuePrecision} = currency;
    return {
      borrowCurrency: o.currency,
      borrowTime: timeUtil.formatDateTime(o.borrowTime),
      amount: numUtil.floor(o.amountRv, valuePrecision, 0),
      type: o.type,
      status: o.status,
      business: o.business,
    };
  });
  return {rows: list, total};
}
